import { RENOVATION_HOUSE } from 'constants/constants';
import * as yup from 'yup';
import { getPartOfValidationSchema } from '../../helpers';

// Bug: the sixth step shows the 'outdoor' features but validates the equipment types of the
// 'energy' group (those of the outdoor features are not required).
const validationSchema = yup
  .object()
  .shape({ ...getPartOfValidationSchema({ projectType: RENOVATION_HOUSE, groupName: 'energy' }) });

export default validationSchema;
